import s from './styles/ViewToggle.module.scss'
import { ReactComponent as TableIcon } from 'assets/icons/tableView.svg'
import { ReactComponent as SessionIcon } from 'assets/icons/listView.svg'

export default function ViewToggle({ viewMode, onChange }) {
	return (
		<div className={s.wrap}>
			<button
				type="button"
				className={`${s.btn} ${viewMode === 'table' ? s.active : ''}`}
				onClick={() => onChange('table')}
			>
				<span className={s.icon}>
					<TableIcon />
				</span>
				<span>Assignment View</span>
			</button>
			<button
				type="button"
				className={`${s.btn} ${viewMode === 'curriculum' ? s.active : ''}`}
				onClick={() => onChange('curriculum')}
			>
				<span className={s.icon}>
					<SessionIcon />
				</span>
				<span>Session View</span>
			</button>
		</div>
	)
}
